import { AfterViewInit, Directive, ElementRef, Optional, Renderer2, ViewContainerRef } from '@angular/core';


/**
 * workaround for Chromium's bug in autocomplete=off
 * https://bugs.chromium.org/p/chromium/issues/detail?id=914451
 *
 * working solution was set autocomplete=<non-standard-value> to each of the form inputs
 * and have one unused input without autocomplete
 */
@Directive({
    selector: 'form[autocomplete=off]',
})
export class AutocompleteOffFormDirective implements AfterViewInit {

    constructor(private viewContainerRef: ViewContainerRef, private renderer: Renderer2) {}

    ngAfterViewInit() {
        const hiddenInput = this.renderer.createElement('input');
        this.renderer.setAttribute(hiddenInput, 'name', 'x-disable-chromium-autocomplete');
        this.renderer.setStyle(hiddenInput, 'display', 'none');
        this.viewContainerRef.element.nativeElement.appendChild(hiddenInput);
    }
}


@Directive({
    // just `input` did not work
    selector: 'input[formControlName], input[formControl]',
})
export class AutocompleteOffInputDirective implements AfterViewInit {

    constructor(@Optional() private host: AutocompleteOffFormDirective, private element: ElementRef, private renderer: Renderer2) {}

    ngAfterViewInit() {
        if (this.host) {
            this.renderer.setAttribute(this.element.nativeElement, 'autocomplete', 'x-off');
        }
    }
}
